import { render } from "./CompetenceView.vue?vue&type=template&id=cbd49bde&scoped=true&ts=true"
import script from "./CompetenceView.vue?vue&type=script&lang=ts"
export * from "./CompetenceView.vue?vue&type=script&lang=ts"

import "./CompetenceView.vue?vue&type=style&index=0&id=cbd49bde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd49bde"]])

export default __exports__